import React from 'react'
import { useParams } from 'react-router-dom'
import { Country } from '../Types/countryTypes'
import { useGetCountryByIdQuery, useUpdateCountryMutation } from '../Service/countriesApi'
import { CountriesRoutes } from '../../../Router/path'
import { CircularProgress, Typography } from '@mui/material'
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout'
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import PublicIcon from '@mui/icons-material/Public';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import { useDeleteCountryImageMutation, useGetCountryWithImagesQuery, useUploadCountryImagesMutation } from '../Service/extendedCoutriesApi'
import { countryFields } from '../fields'
import { countryValues } from '../initialValues'
import AccordionCard from '../../Shared/Components/AccordionCard/AccordionCard'
import ImageIcon from '@mui/icons-material/Image';
import UploadedImagesGallery from '../../Shared/Components/UploadedImagesGallery/UploadedImagesGallery'
import UploadImagesForm from '../../Shared/Components/UploadImagesForm/UploadImagesForm'
import { extractCountryEntityFormApiErrors } from '../Utils/countryEntityFormApiErrorHandling';

const EditCountry = () => {
    const { countryId } = useParams<{ countryId: string }>()
    const parsedCountryId = countryId ? parseInt(countryId) : 0;
    const { data: countryData, isLoading: isCountryLoading, error: countryError } = useGetCountryByIdQuery(parsedCountryId, {
        skip: !countryId,
    });
    const {
        data: countryWithImagesData,
        isLoading: isImagesLoading,
        isError: isImagesError
    } = useGetCountryWithImagesQuery(parsedCountryId)

    const [updateCountry, updateStatus] = useUpdateCountryMutation();
    const [uploadCountryImages, uploadState] = useUploadCountryImagesMutation();

    const entityForm = useEntityForm<Country>({
        initialData: countryData ?? countryValues,
        fields: countryFields,
        submitFn: (data) => updateCountry({ id: parsedCountryId, data }).unwrap(),
        redirectUrl: CountriesRoutes.root,
        title: 'Edytuj kraj',
        icon: <PublicIcon />,
        backUrl: CountriesRoutes.root,
        groupOrder: ['Podstawowe', 'SEO', 'Konfiguracja'],
        groupIcons: {
            Podstawowe: <InfoIcon />,
            SEO: <SearchIcon />,
            Konfiguracja: <SettingsIcon />
        },
        mutationStatus: updateStatus,
        errorExtractor: extractCountryEntityFormApiErrors,

    })


    if (isCountryLoading) {
        return (
            <Typography align="center" sx={{ mt: 4 }}>
                <CircularProgress />
            </Typography>
        );
    }

    if (countryError) {
        return (
            <Typography color="error" align="center" sx={{ mt: 4 }}>
                Nie udało się załadować danych kraju.
            </Typography>
        );
    }

    return (
      <EntityFormLayout {...entityForm}>
        <AccordionCard title="Wgrane zdjęcia" icon={<ImageIcon />}>
          {countryWithImagesData?.images?.length ? (
            <>
              <UploadedImagesGallery
                images={countryWithImagesData.images}
                isLoading={isImagesLoading}
                isError={isImagesError}
                useDeleteMutation={useDeleteCountryImageMutation}
                mutationParams={(imageId) => ({ imageId, countryId: parsedCountryId })}
              />
              <UploadImagesForm
                useUploadMutation={() => [uploadCountryImages, uploadState]}
                mutationParams={(files) => ({ countryId: parsedCountryId, files })}
              />
            </>
          ) : (
            <Typography color="text.secondary" component="div">
              Nie wgrano jeszcze żadnych zdjęć.
              <UploadImagesForm
                useUploadMutation={() => [uploadCountryImages, uploadState]}
                mutationParams={(files) => ({ countryId: parsedCountryId, files })}
              />
            </Typography>
          )}
        </AccordionCard>
      </EntityFormLayout>
    );
}

export default EditCountry
